import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCommonModule } from '@angular/material/core';
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from "@angular/material/tabs";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';

const components = [CommonModule, FormsModule];
const MaterialModule = [
  MatButtonModule,
  MatIconModule,
  MatInputModule,
  MatSlideToggleModule,
  MatCardModule,
  MatDialogModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatTableModule,
  MatDividerModule,
  MatCommonModule,
  MatToolbarModule,
  MatTabsModule,
  MatListModule,
  MatSelectModule,
  MatSortModule,
  ReactiveFormsModule,
  MatGridListModule,
  MatProgressSpinnerModule,
  MatChipsModule,
  MatCheckboxModule,
  MatDatepickerModule,
];



@NgModule({
  declarations: [],
  imports: [...components, ...MaterialModule],
  exports: [...components, ...MaterialModule]
})
export class SharedModule { }
